// @ts-nocheck
import { resolveColor, safeColor } from "@insite/mobius/utilities";
import { ButtonPresentationProps } from "@store/MobiusOverrides/Button/Props";
// import { buttonStyles } from "@store/Themes/common/mixins/button"; // Store Custom Code
import cssProp from "@toolkit/Framework/Common/Utilities/cssProp";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { ButtonType, MobiusButtonType } from "@toolkit/Framework/Types/Button";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { buttonGetHoverProps } from "@toolkit/Themes/common/props";
import { css } from "styled-components";

/* Store Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
import { buttonStyles } from "@store/Themes/common/mixins/button";
/* Store Custom Code - End */

/* ------------------------------------------------------------------------------------------ */
/* Related Extensions => src/Extensions/Mobius/Button --------------------------------------- */
/* ------------------------------------------------------------------------------------------ */

interface ButtonOptions {
    color: string;
    type: ButtonType;
    hoverColor?: string;
    hoverTextColor?: string;
}
/* Store Custom Code - Start */
const getButton = (color: string, type: ButtonType): ButtonPresentationProps => ({
    shape: "rounded",
    buttonType: type as MobiusButtonType,
    typographyProps: {
        weight: "inherit",
    },
    color,
    css: buttonStyles(type),
});
/* Store Custom Code - End */

interface SelectionButtonOptions {
    color: string;
    hoverColor: string;
    textColor?: string;
    showBackground?: boolean;
}

/* Store Custom Code - Removed getSelectionButton */
/* const getSelectionButton = (options: SelectionButtonOptions = { color: "", hoverColor: "", showBackground: true }) =>
    mergeProps<ButtonPresentationProps>(
        getButton({ color: options.color, type: "outline", hoverColor: options.hoverColor }),
        {
            css: css`
                max-width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                ${({ theme }) => {
                    return css`
                        ${cssProp("color", options.textColor, x => resolveColor(x, theme))}
                        ${options.showBackground
                            ? `background-color: ${safeColor(resolveColor(options.color, theme)).alpha(0.1)};`
                            : null}
                    font-weight: ${theme.design.typography.weight.base};

                        &:disabled {
                            background-color: ${safeColor(theme.colors.button.disabled.contrast).alpha(0.1).toString()};
                        }
                    `;
                }};
            `,
        },
    ); */

const tertiaryButtonProps = getButton("secondary", "outline"); // Store Custom Code

const button: Styleguide["button"] = {
    /* Store Custom Code - Start */
    primary: {
        ...getButton("primary", "solid"),
        ...buttonGetHoverProps("secondary"), // Store Custom Code
    },
    secondary: {
        ...getButton("secondary", "solid"),
        ...buttonGetHoverProps("secondary.dark"), // Store Custom Code
    },
    tertiary: {
        ...tertiaryButtonProps,
        css: css`
            ${tertiaryButtonProps.css}

            &:not(:disabled):hover {
                background-color: ${getColor("secondary")};
                border-color: ${getColor("secondary")};
                color: ${getColor("secondary.contrast")};
            }
        `,
    },
    /* Store Custom Code - End */
};

export default button;
